var map = {
	"./music-instructions.json": 4733,
	"./music-library-intro2024.json": 4734,
	"./music-library-launch2024.json": 4735,
	"./music-progression.json": 4736,
	"./startSourcesAdvanced.json": 4737,
	"./startSourcesSimple.json": 4738,
	"./startSourcesSimple2.json": 4739,
	"./startSourcesTracks.json": 4740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4501;